
define('text!templates/modules/forum/summary/forum-summary.html',[],function () { return '<div class="forum-content"></div>\n';});

